/** @internal */
export class VideoQuality {
    public readonly Width: number;
    public readonly Height: number;
    public readonly FrameRate: number;
    public readonly AspectRatio: string;
    public readonly MaximumConnections: number;

    // public get CalculatedAspectRatio(): number {
    //     const spl = this.AspectRatio.split(":").map(x => Number(x));
    //     return spl[0] / spl[1];
    // }

    private constructor(width: number, height: number, frameRate: number, aspectRatio: string, maxConnections: number) {
        this.Width = width;
        this.Height = height;
        this.FrameRate = frameRate;
        this.AspectRatio = aspectRatio;
        this.MaximumConnections = maxConnections;
    }

    public Compare(o: VideoQuality): boolean {
        return this.Width == o.Width &&
            this.Height == o.Height &&
            this.AspectRatio == o.AspectRatio &&
            this.MaximumConnections == o.MaximumConnections;
    }

    public static Create(width: number, height: number, frameRate: number, aspectRatio: string, maxConnections: number): VideoQuality {
        return new VideoQuality(width, height, frameRate, aspectRatio, maxConnections);
    }
}